import { render, staticRenderFns } from "./wanneer-ramen-plaatsen.vue?vue&type=template&id=8d24ad26"
import script from "./wanneer-ramen-plaatsen.vue?vue&type=script&lang=js"
export * from "./wanneer-ramen-plaatsen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports